import type { Transaction } from '@atlaskit/editor-prosemirror/state';
import { PluginKey } from '@atlaskit/editor-prosemirror/state';
import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { isFedRamp } from '@atlaskit/atlassian-context';

import type { StepsDatabase } from '../stepsDatabase';

export type EditorOfflineStoragePluginStatus = 'pending' | 'restoring' | 'ready' | 'tooManyRetries';

export type EditorOfflineStorageDisabledReason =
	| 'disabledEnvironment'
	| 'stepsDatabaseError'
	| 'tooManyRetries'
	| 'unableToSync'
	| 'indexedDBAccessError';

export type EditorOfflineStoragePluginState = {
	status: EditorOfflineStoragePluginStatus;
	disabled: EditorOfflineStorageDisabledReason | false;
	inactiveSyncing: boolean;
};

export const editorOfflineStoragePluginKey = new PluginKey<EditorOfflineStoragePluginState>(
	'editorOfflineStoragePlugin',
);

export const createPlugin = (stepsDatabase: StepsDatabase) => () => {
	return new SafePlugin<EditorOfflineStoragePluginState>({
		key: editorOfflineStoragePluginKey,
		state: {
			init() {
				return {
					status: 'pending',
					disabled: isFedRamp() ? 'disabledEnvironment' : false,
					inactiveSyncing: false,
				};
			},
			apply: (tr: Transaction, currentPluginState: EditorOfflineStoragePluginState) => {
				const meta = tr.getMeta(editorOfflineStoragePluginKey);
				if (meta) {
					return {
						...currentPluginState,
						...meta,
					};
				}
				return currentPluginState;
			},
		},
		view: () => {
			return {
				destroy() {
					return stepsDatabase.closeDB(true);
				},
			};
		},
	});
};
